import { render, staticRenderFns } from "./christchurchCallingTC.vue?vue&type=template&id=343a3302&scoped=true&"
import script from "./christchurchCallingTC.vue?vue&type=script&lang=js&"
export * from "./christchurchCallingTC.vue?vue&type=script&lang=js&"
import style0 from "./christchurchCallingTC.vue?vue&type=style&index=0&id=343a3302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343a3302",
  null
  
)

export default component.exports